import { Link } from "react-router-dom";
import { ChevronRight, Clipboard } from "lucide-react";

// #1221 slice 5 (D214 L7, D298): the coach's way from one player's page to the
// full record. The row carries no count and no figure, in every state (the
// board's no-matches frame draws it unchanged). Coach-player leg only: the
// caller is `CoachPlayerScreen`, which the flag-off page and admin never mount.
const ROW = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 10,
  minHeight: 52,
  boxSizing: "border-box",
  padding: "8px 14px",
  background: "var(--nw-surface)",
  border: "1px solid var(--nw-line)",
  borderRadius: 12,
  textDecoration: "none",
  // D259: the board's column gap is 14px. The inline margin beats the parent's
  // `space-y-6` (the same placement trap the back link documents).
  marginTop: 14,
};

export default function CoachFullRecordRow({ playerId }) {
  return (
    <Link
      to={`/coach-portal/record?player=${encodeURIComponent(playerId)}`}
      aria-label="Full record"
      data-testid="cp-full-record-link"
      style={ROW}
    >
      <span style={{ display: "flex", alignItems: "center", gap: 10, minWidth: 0 }}>
        <Clipboard size={16} color="var(--nw-navy)" aria-hidden="true" style={{ flexShrink: 0 }} />
        <span style={{ display: "flex", flexDirection: "column", gap: 1, minWidth: 0 }}>
          <span style={{ fontSize: 15, lineHeight: 1.2, fontWeight: 700, color: "var(--nw-ink)" }}>Full record</span>
          <span style={{ fontSize: 12, lineHeight: 1.2, color: "var(--nw-ink-muted)" }}>Every match and figure, read-only</span>
        </span>
      </span>
      <ChevronRight size={18} color="var(--nw-navy)" aria-hidden="true" style={{ flexShrink: 0 }} />
    </Link>
  );
}
